module.exports = {
  language: {
    name: 'English'
  },
  user: {
    login:'登录',
    register:'注册',
    loginUsername:'请输入邮箱/手机号',
  },
  menu:{
    home:'首页',
    overview:'描述',
    gallery:'画廊',
    gallerybinance:'币安 NFT',
    myWallet:'我的钱包',
    walletHistory:'钱包历史',
    title:'哈希熊猫',

    WeChat:'微信',

  },
  home:{
    czsc:'https://www.yuque.com/docs/share/86d77020-688b-4781-b263-4bd15129fd98',

    number:'份数',
    qb:'怎么购买？(Binance Smart Chain(BSC)+MetaMask 或 TokenPocket)',
    pay:'支付',
    pay1:'最大购买',
    mxt:'用心打造中国特色的NFT！感受中国文化和中国人物',
    mx:'HashPands 是全球第一个中国特色熊猫主题NFT作品,由全球热爱熊猫的艺术家参与创作,它由15,976个独特的数字艺术肖像的组成！',
    mx1:'这也是您成为第一个参加现有熊猫主题和中国特色的最大的NFT合作艺术项目的机会。',
    hs:' 这个价格还剩',
    ipfs:'居住在Binance Smart Chain(BSC)区块链上',
    xt:'下一代数字艺术收藏品',
    xtt1:'HashPands引入了数字艺术和收藏品的组合,其价值层次由艺术品的创造者和消费者决定。与其他收藏品不同的是,所有特征都是由创造者确定的,HashPands包括三层稀缺性：它提供了一组特征以向消费者提供一般指导,但是它还创建了许多未解释的隐含特征。最重要的是,对所有稀有特征(即名称)的控制权完全交给了消费者。部分稀有NFT作品可以自由合成一张展示(平台可提供专栏展示)',
    xn2:'命名通过名称更改令牌(NCT)进行商品化,可以与艺术品的其他参与者互换。每个名称都是唯一的,并且只能属于一个NFT。Hashpandas是一个收藏品,其中收藏中每件作品的价值和稀有性都不是预先确定的，但会在许多年后发生变化和适应，直到最后一个 NCT 被烧毁为止',
    xn3a:'阅读宣言',
    mj1:'最初由消费者确定的几层稀缺性的收藏品',
    mj2:'由全球100多位艺术家创作',
    mj3:'随机分配以实现完全公平',
    mj4:'消费者通过其NFT拥有全部所有权和无限制的商业使用权。',
    mj5:'通过NCT令牌机制,命名成为稀缺商品',
    mj6:'收藏品,游戏,尤其是艺术品',
    xt2:'这个怎么运作',
    xt2n1:'总共有15,976个唯一的HashPands。他们每个人都是由几位不同的艺术家共同创作的。它们具有不同的面具,颜色,道具,熊猫和其他属性。这意味着：所有HashPands都很少,但是有些比其他还少。',
    xt2n2:'为确保公平分配，用户将不知道他们在销售的前 7 天购买了什么 Hashmask。所有 NFT 都已生成，但尚未编入索引。有一个预先确定的 Hashmask 序列，但是第一个 HashPandas 将仅在销售结束时使用',
    xt2n3:'链上随机机制确定',
    xn2n4:'这种方法保证了公平的分配。由于初始分发期间的预期需求量很大，我们决定限制每笔交易最多 20 个哈希掩码。',
    xn2n5:'分发期从2021年5月31日(中国标准时间)的16:00开始。HashPands将根据以下时间表出售(视',
    xn2n6:'FAQ中',
    xn2n7:'的价格滑落而定).在7天之后或所有的Hashpandas被出售后(以较早者为准),贡献期结束,剩余Hashpandas将都被显示。如果在展示阶段之后仍未售出,则销售将以当时的速度继续进行,有两个差异:(1)所有肖像都将被展示,因此您知道要购买哪幅肖像;(2)7天之内将没有奖金NCT了。',
    xn2n8:'永生于链上',
    xn2n9:'您不仅仅是在购买一件稀有艺术品。您是艺术品的一部分。智能合约允许您为HashPands分配名称,从而使您能够将独特的笔划添加到画布。因此,您成为了将原始画布塑造成永恒艺术品的创始人之一。随着我们向完全数字经济的转变,您的NFT可以充当您的数字身份。',
    xn2n10:'介绍NCT',
    xn2n11:'每天,每个HashPands会累积10个名称更改令牌(NCT),当前持有人可以索取。当您拥有1,830个NCT(约价值½年的NCT)时,您可以刻录这些令牌并更改链上HashPands的名称。智能合约要求每个名称都必须唯一,从而在艺术品中造成第二层稀缺性。整整十年之后,即2031年1月26日(时间戳：19214206000),将发布最后一个NCT,从那时起,供应将减少直到一天,最后一个NCT令牌被烧毁,并且艺术品完成。',
    xn2n112:'HashPandas将支持NCT代币兑换限量版NFT线下周边，以及未来待定彩蛋(暂不公开)。',

    hct:'合成介绍',
    gxt:'特别感谢',
    gxn:'感谢Hashmasks，才有了本平台的诞生！',
    hcn:'HashPands提供熊猫新郎，熊猫新娘艺术品，可以合成一张，原有图片保留，生成一张新艺术品，组成结婚场景，数量稀有，新娘更是稀有，形成第三层稀缺(平台可以提供专栏展示)',
    xn2n12:'在贡献期的前7天中,任何参与者都将获得价值1年的NCT(3,660个NCT,相当于两次更名)。在7天之后,每个HashPands都将以足够的供应开始,以进行单个名称更改(1,830个NCT)。',
    xn2n13:'经验证的智能合约',
    sth:'合作伙伴',
    st:'NFT生态合作',
    stn:'若您和您的团队想合作，请联系：nft@hashpandas.com',
   zbt:'周边',
    zbn:'HashPandas未来提供NCT兑换和销售HashPandas衣服，裤子，帽子，手机壳，周边等等销售，HashPandas持有者，并且享有销售分红，用户也可以直接印制自己的NFT到自己喜欢的衣服或相关任何地方；案例如下：',
    
    syt:'商业NFT计划',
    sytn:'HashPandas注重NFT艺术价值和商业价值，致力于NFT艺术家、持有者、合作商、项目方互联的商业生态圈建设，我们希望通过NFT线上线下的品牌发展让艺术品产生更大的价值，使生态圈各个角色的商业利润最大化，在这个生态圈里主要包含四个角色；',
    sytn1:'艺术家：熊猫文化艺术品的创造者，分享热爱的设计作品，获得流量曝光提升知名度，同时享受商业提成回报。',
    sytn2:'持有者：持有艺术品，在持有期间永久享受品牌线下文化商业运营收益。',
    sytn3:'合作商：品牌战略合作中推动品牌文化发展的重要互补品牌、商业合作品牌、投资方等。',
    sytn4:'项目方：负责品牌运营、品牌合作、品牌文化的所有工作，推出激励计划来支持艺术家加入和创作，提升各角色的商业发展空间，促成生态圈稳定发展。',
    sytn5:'  商业生态圈之外，我们集结所有的熊猫爱好者共建哈希熊猫社区，举办非商业性的熊猫主题竞赛和公益性的艺术价值活动，线上线下同时发展，让生态圈各角色感受到熊猫的魅力，获得更好的体验感；只要你热爱熊猫，就可以加入我们的社区，一起为哈希熊猫打CALL!',
    ktt:'空投计划',
    kttn1:'我们做了一个大胆的想象，以哈希熊猫社区的身份向灾区空投我们的捐献物资，那会是一件多么令人振奋的事情！并且我们期待有一天联合艺术家和熊猫爱好者一起，向偏远山区送上我们的艺术画册，甚至和当地的学生一起画上几只熊猫，欢迎您来和我们一起构建计划，我们为之努力着...',
    kttn2:'社区同时不定期向熊猫爱好者空投NFT、NCT等数字艺术品，更有机会通过社区获得免费的NFT线下限量周边，例如服装、画册、手机壳等，这些装饰艺术品将由艺术家联合共创推出。',
    nctdh:'NCT兑换',
    nctdhn:'HashPandas将支持NCT代币兑换限量版NFT线下周边，以及未来待定彩蛋(暂不公开)。'
  }
  ,
  gallery:{
      qh:'亲爱的，你愿意嫁给我吗？ ',
      jgw:'宝贝，嫁给我！',
      xx:'是的，我愿意！',
      x2tn:'不管考的怎么样！',
      x2tn2:'爸爸妈妈都爱你！',
      x2t:'三星堆黄金面具人：满城黄金甲,悠悠千古！烽影万古扬,巍巍荡荡！',
      x2t2:'祝： 芊芊学子，高考旗开得胜！金榜题名！不负韶华！',

      x3t:'我不胖我只是毛茸茸的,我希望所有的人类也是熊猫,这样他们也可以像我们一样放松.',
      x3tn:'带我回家！',
  },
  
  galleryNFT:{
      titile:'币安 NFT上线 HashPandas 画廊！（其中100幅画）',
  },


  overview:{
      ti:'明确的稀有度',
      tin:'为了对数字收藏艺术品的层次结构给出一般性指导，创作者提供了一组具有不同稀有程度的明确特征，例如男性比女性熊猫更常见。与其他收藏品不同，通过隐性特征和名称市场，在显性特征之上还有第二层稀缺性。',
      ti2:'隐性稀有度',
      tin2:'Hashpads 不是简单的收藏品，但它们是艺术。而且艺术不是系统的。它是神秘的。作为智能设计的收藏品和艺术创作的最重要融合，许多 Hashpandas 特征或属性没有明确说明。它鼓励消费者或更确切地说是集体消费者将他或她对价值的解释投射到艺术品中。最重要的是，NCT 将所有特征中最稀有的决定权，一个独特的名字，传递给消费者，从而消除了艺术作品创作者和消费者之间的无形界线。',
      ti3:'隐式稀有度示例',
      tin3:'在最高级别，有21种不同类型的面具，有16种不同类型的熊猫？%的所有角色都戴着面具，只有？%的熊猫。乍一看，？熊猫可能看起来更独特，但经过进一步观察，您会发现只有 ?% 的特色熊猫，这比所有熊猫中最稀有的要独特得多。其他具有不同稀有度的隐性特征的例子是背景、衣服、武器、面具和颜色等等。',
  },
  nct:{
    ti1:'NCT TOKEN是什么？',
    tin11:'名称更改令牌 (NCT) 是 Hashpandas 艺术品的原生令牌。NCT 只有一个目的：它允许其持有者为其 Hashpandas 指定一个唯一名称，该名称永久存储并在 BSC 区块链上公开可见。因此，将名称本身商品化并使其成为整个项目中所有属性中最稀有的。这为收藏品开辟了一个全新的维度，其中整个集体艺术的各个作品的价值等级受到消费者偏好的高度影响。',
    tin12:'如果您拥有 Hashpandas，则可以领取 NFT 累积NCT。每个 NFT 每年累积约 3,660 个 NCT。如果您参与初始供款期，您将获得额外的 1,830 NCT。要更改 NFT 的名称，您需要向 Hashpandas 合约发送 1,830 个 NCT（约 ½ 年的 NFT 排放量）并销毁它们。',
    ti2:'规则',
    tin21:'名字不能相同',
    tin22:'有 25 个符号的限制（包括空格）',
    tin23:'唯一性不区分大小写（即 «John» 和 «john» 在区块链中被视为相同）',
    tin24:'没有开头或结尾的“空格”',
    tin25:'只有字母数字符号才有资格使用',
    tin26:'NFT 名称更改后，已使用的名称立即可用',
    ti3:'NCTs的排放率',
    tin31:'每年，每个 Hashpandas 将累积大约 3,660 个 NCT。您需要 1,830 个 NCT 才能更改您的 Hashpandas 的名称。为了赋予早期参与者更多的决定权，每个参与者在第一个分发期（7 天）将额外收到 1,830 个 NCT。10 年后，新 NCT 的发射停止。从那以后，NCTs 只能被烧毁，直到有一天 NCTs 没有留下，Hashpandas 的名字不能再改变了。然后，艺术品被认为是完整的。',
    tin32:'每个 NFT 每年发出的 NCT 数量：3,660',
    tin33:'一次更名所需的 NCT 数量：1,830',
    tin34:'初始销售阶段的奖励 NCT：1,830',
    accumulated:'累计 NCT',
    owneds:'拥有 哈希熊猫',
    ownedsBy:'所有者',
    yourwallet:'我的钱包',
    claimall:'全部提取',
    claim:'提取',
    walletNCT:'钱包 NCT',
    ynnft:'你没有哈希熊猫，去拿一个吧！',

    changeName:'修改名称',
    insufficientNct:'您的钱包里余额不足',
    leaseNct:'请提取您的NCT，然后再试一次',
    enterN:'输入新名称',
    entertN:'输入新名称',
    namingHistory :'命名历史',
    unnamed:'未命名',

  }
}